<template>
  <div>
    <ion-item class="search">
      <ion-label position="floating">
        Search
      </ion-label>
      <ion-input-vue v-model="search" />
    </ion-item>

    <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="50"
        :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
        :search="search"
        :loading="busy"
    >
      <template v-slot:item.email="{ item }">
        {{ item.email }}
        <template v-if="item.role === 'OWNER'">
          ({{ settings.recoveryEmail }})
        </template>
      </template>

      <template v-slot:item.lastSeen="{ item }">
        {{ item.lastSeen }}
      </template>

      <template v-slot:item.actions="{ item }">
        <ion-button
            :disabled="item.busy"
            @click="reinvite(item.uuid)"
        >
          <ion-spinner v-if="item.busy" />
          <template v-else>
            Reinvite
          </template>
        </ion-button>
        <ion-button
            v-if="item.role === 'OWNER'"
            @click="reassignOwner"
        >
          Reassign owner
        </ion-button>
        <ion-button
            v-else
            @click="remove(item)"
        >
          <ion-spinner v-if="item.busy" />
          <template v-else>
            Remove
          </template>
        </ion-button>

      </template>

      <template slot="footer.prepend">
        <ion-button @click="invite">
          Invite
        </ion-button>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import { VDataTable } from 'vuetify/lib'
import { modalController, IonInputVue } from '@modus/ionic-vue'
import RemoveUser from './RemoveUser'
import InviteUser from './InviteUser'
import ReassignOwner from './ReassignOwner'

export default {
  components: {
    VDataTable,
    IonInputVue,
  },
  data () {
    return {
      serialNumber: this.$route.params.serialNumber,
      search: '',
      busy: false,
    }
  },
  computed: {
    bridge () {
      return this.$store.getters.getBridgeBySerial(this.serialNumber)
    },
    users () {
      return this.bridge.users || []
    },
    settings () {
      return this.bridge.settings
    },
    headers () {
      return [
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Role',
          value: 'role',
        },
        {
          text: 'Last Seen',
          value: 'lastSeen',
        },
        {
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  async mounted () {
    const serialNumber = this.serialNumber
    this.busy = true

    try {
      await this.$store.dispatch('fetchUsers', { serialNumber })
      await this.$store.dispatch('fetchBridgeSettings', { serialNumber })
    } catch (e) {
      // ignore
    }
    this.busy = false
  },
  methods: {
    async reinvite (uuid) {
      const serialNumber = this.serialNumber
      this.busy = true

      await this.$store.dispatch('reinviteUser', { serialNumber, uuid })

      this.busy = false
    },
    lastSeen (_, user) {
      return this.$options.filters.datetime(user.lastSeen)
    },
    async invite () {
      const modal = await modalController.create({
        component: InviteUser,
        componentProps: {
          propsData: {
            serialNumber: this.serialNumber,
          },
        },
      })

      await modal.present()
    },
    async remove (user) {
      const modal = await modalController.create({
        component: RemoveUser,
        componentProps: {
          propsData: {
            serialNumber: this.serialNumber,
            user,
          },
        },
      })

      await modal.present()
    },
    async reassignOwner () {
      const modal = await modalController.create({
        component: ReassignOwner,
        componentProps: {
          propsData: {
            serialNumber: this.serialNumber,
          },
        },
      })

      await modal.present()
    },
  },
}
</script>
